export const workorderRoutes = [
  'migration-consult',
  'calendar',
  'indicators',
  'import',
];
